<template>
    <v-menu offset-y :close-on-content-click="false" v-model="display">
        <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" class="mx-1">
                <v-icon>mdi-magnify</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-text>
                <v-text-field
                    dense
                    label="Code"
                    append-icon="mdi-pound"
                    v-model="form.code"
                ></v-text-field>
                <customer-search
                    label="Customer"
                    item-text="display_name"
                    item-value="id"
                    v-model="form.customer_id"
                >
                </customer-search>
                <p-date-picker
                    label="From"
                    v-model="form.from"
                    @update="form.to = form.from"
                >
                </p-date-picker>
                <p-date-picker label="To" v-model="form.to" :min="form.from">
                </p-date-picker>
                <v-select
                    dense
                    label="State"
                    v-model="form.state"
                    :items="states"
                    clearable
                >
                </v-select>
            </v-card-text>
            <v-card-actions>
                <v-btn text color="primary" @click="submit">Search</v-btn>
                <v-btn text @click="resetForm">Reset</v-btn>
            </v-card-actions>
        </v-card>
    </v-menu>
</template>

<script>
import PDatePicker from "../common/PDatePicker.vue";
import CustomerSearch from "../searchComponents/CustomerSearch";

export default {
    name: "CreditNotesSearchMenu",
    components: { CustomerSearch, PDatePicker },
    props: {
        value: Boolean,
        search: Object
    },
    data() {
        return {
            formSkeleton: {
                code: null,
                customer_id: null,
                from: null,
                to: null,
                state: null,
            },
            states: [
                { text: "Draft", value: "DRAFT" },
                { text: "Posted", value: "POSTED" },
            ],
        };
    },
    computed: {
        display: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            },
        },
        form: {
            get() {
                return this.search;
            },
            set(val) {
                this.$emit("update:search", val);
            }
        }
    },
    methods: {
        submit() {
            this.$emit("submit");
        },
        resetForm() {
            this.form = { ...this.formSkeleton };
        },
    },
    created() {
        this.resetForm();
    },
};
</script>
